module.exports = new __parcel__URL__("medical_academy_level_2.eaa8ce6a.png").toString();